const columns = [
    {
        field: 'kod_numobj',
        text: 'ID',
        visible: false,
    },
    {
        field: 'kod_obj',
        text: 'kod_obj',
        visible: false,
    }, // {field: 'kod_parent_sa',text: 'kod_parent_sa'},
    // {field: 'kod_f23',text: 'kod_f23'},
    {
        field: 'name23',
        text: 'Классификатор потребителя',
    }, // {field: 'pr_active',text: 'pr_active'},
    {
        field: 'active_abbr',
        text: 'Статус',
    }, // {field: 'tep_el',text: 'tep_el'},
    {
        field: 'tep_el_name',
        text: 'Тепловой \\ Электрический',
    }, // {field: 'tarif',text: 'tarif'},
    {
        field: 'tarif_name',
        text: 'Тарифная группа',
    },
    {
        field: 'kod_dog',
        text: 'kod_dog',
        visible: false,
    },
    {
        field: 'ndog',
        text: '№ Договора',
    },
    {
        field: 'dep',
        text: 'dep',
        visible: false,
    },
    {
        field: 'dep_name',
        text: 'Филиал (Отделение)',
    },
    {
        field: 'kodp',
        text: 'kodp',
        visible: false,
    },
    {
        field: 'contragent_name',
        text: 'Контрагент',
    },
    {
        field: 'kodagent',
        text: 'kodagent',
        visible: false,
    },
    {
        field: 'ag_name',
        text: 'Субъект деятельности',
    },
    {
        field: 'num_obj',
        text: 'Номер',
    },
    {
        field: 'name',
        text: 'Наименование',
    }, // {field: 'kodnaznhouse',text: 'kodnaznhouse'},
    {
        field: 'naznhouse_name',
        text: 'Назначение сооружения',
    },
    {
        field: 'dat_create',
        text: 'Создан',
    },
    {
        field: 'dat_parent_create',
        text: 'Начало действия в тек. дог.',
    },
    {
        field: 'dat_fin',
        text: 'Прекращен',
    },
    {
        field: 'dat_plan_fin',
        text: 'Планируемое окончание',
    },
    {
        field: 'dat_tp',
        text: 'Дата техн. присоед.',
    },
    {
        field: 'dat_postav_obj',
        text: 'Начало поставки',
    },
    {
        field: 'dat_replace',
        text: 'dat_replace',
        visible: false,
    },
    {
        field: 'prizn_prn',
        text: 'Печать списком',
        alignment: 'center',
    }, // {field: 'kod_parent_obj',text: 'kod_parent_obj'},
    {
        field: 'parent_obj',
        text: 'Переоформлен с …',
    },
    {
        field: 'prim',
        text: 'Примечания',
    }, // {field: 'kodd',text: 'kodd'},
    {
        field: 'kf_adress_o',
        text: 'Адрес',
    },
    {
        field: 'fias',
        text: 'Адрес',
    }, // {field: 'kod_uslotkl',text: 'kod_uslotkl'},
    {
        field: 'usl_abbr',
        text: 'Условия отключений',
    },
    {
        field: 'tlg_och',
        text: 'Очередь отключения',
    },
    {
        field: 'askue',
        text: 'АСКУЭ',
        alignment: 'center',
    }, // {field: 'kod_obj_fs',text: 'kod_obj_fs'},
    {
        field: 'fs_abbr',
        text: 'Принадл. оборуд. на праве',
    },
    {
        field: 'dat_beg_arend',
        text: 'Дата начала',
    },
    {
        field: 'dat_end_arend',
        text: 'Дата окончания',
    },
    {
        field: 'vkl530',
        text: 'Перечень по пост. 442',
        alignment: 'center',
    },
    {
        field: 'bezdog',
        text: 'Бездоговорное использование',
        alignment: 'center',
    },
    {
        field: 'divergence_percent',
        text: 'Допустимый %откл. Факт. расхода',
    },
    {
        field: 'pr_avans',
        text: 'Участие в расчете аванса',
        alignment: 'center',
    }, // {field: 'zone',text: 'zone'},
    {
        field: 'zone_name',
        text: 'Зона',
    }, // {field: 'kodp_usl',text: 'kodp_usl'},
    {
        field: 'name_usl',
        text: 'Сетевая организация',
    },
    {
        field: 'point_sale',
        text: 'Описание точки поставки',
    },
    {
        field: 'pr_dog_tehpris',
        text: 'Договор техн. присоед.',
        alignment: 'center',
    },
    {
        field: 'es_id',
        text: 'Ид-р внешней системы (И)',
    },
    {
        field: 'es_ids',
        text: 'Ид-ры внешних систем',
    },
    {
        field: 'kodp_seti',
        text: 'kodp_seti',
        visible: false,
    },
    {
        field: 'seti_name',
        text: 'seti_name',
        visible: false,
    },
    {
        field: 'mkd_pr_unsafe_house',
        text: 'Аварийный МКД',
        alignment: 'center',
    },
    {
        field: 'mkd_date_excld_calc',
        text: 'Дата искл. из расчетов по насел.',
    },
    {
        field: 'square_oi',
        text: 'Площадь общего имущества, кв.м',
    },
    {
        field: 'square',
        text: 'Площадь объекта, кв.м.',
    },
    {
        field: 'kol_kom',
        text: 'Кол-во комнат (помещ.)',
    },
    {
        field: 'apartment',
        text: 'Кол-во квартир',
    },
    {
        field: 'square_rent',
        text: 'Площадь аренды, кв.м',
    },
    {
        field: 'nrm_soi',
        text: 'Норматив СОИ, кВт*ч/кв.м',
    }, // {field: 'kod_dopdoc',text: 'kod_dopdoc'},
    {
        field: 'uin',
        text: 'УИН',
    },
    {
        field: 'req_crm',
        text: '№ заявки в CRM',
    },
    {
        field: 'req_lk',
        text: '№ заявки в ЛКП',
    },
];

export default {
    columns: columns,
    loadUrl: 'object./object-list/data/get',
    keyExpr: 'kod_numobj',
    createViewRoutName: 'ObjectCardNew',
    toRemoveToolbarItemsNames: ['choice', 'copy', 'save'],
    viewId: 'view-object-list',
};
